// extracted by mini-css-extract-plugin
export default {"-large":"cropping-presets-module__-large--W6AGJ","croppingPresetItem":"cropping-presets-module__croppingPresetItem--PusMJ"};